import { useQuery } from '@apollo/client';
import { LoadingOrError } from '@retainerclub/common';
import { CustomerCard } from '@retainerclub/customer-shared';
import { useAuth } from '@retainerclub/hooks';
import { GET_SUBSCRIPTIONS } from '@retainerclub/shared-api';
import PropTypes from 'prop-types';
import DashboardSubscriptionsTable from './DashboardSubscriptionsTable';

function DashboardSubscriptions({ handleOpenManageSubscription }) {
  const { currentUser } = useAuth();

  const { loading, error, data } = useQuery(GET_SUBSCRIPTIONS, {
    skip: currentUser === null || currentUser === undefined,
  });

  // Render straight from the query. This used to be mirrored into local state behind a
  // `length > 0` guard, which meant the list could never shrink and never dropped a plan the
  // customer had just changed — they saw the old plan after a successful downgrade and retried.
  const subscriptions = data?.subscriptions ?? [];

  const shouldRender = LoadingOrError({
    loading,
    error,
    title: 'Plans',
  });

  if (shouldRender) {
    return (
      <CustomerCard
        title="Plans"
        description="We'll start reminding you of your next anniversary 30 days before it renews."
      >
        <DashboardSubscriptionsTable
          subscriptions={subscriptions}
          handleOpenManageSubscription={handleOpenManageSubscription}
        />
      </CustomerCard>
    );
  }

  return shouldRender;
}

DashboardSubscriptions.propTypes = {
  handleOpenManageSubscription: PropTypes.func.isRequired,
};

export default DashboardSubscriptions;
